onComplete(function() {
	// Agenda texts open with an "Info:" heading, which the card previews would otherwise repeat.
	document.querySelectorAll('.blog-item-preview-text').forEach(function(text) {
		text.textContent = text.textContent.replace(/^\s*Info:\s*/, '');
	});

	// Event cards show the date as a large day number with a short month below it, next to the
	// title. The agenda preview only outputs one formatted date ("24 oktober 2026"), so it is split here.
	document.querySelectorAll('.home-events-feed .blog-field-date, .blog-template-agenda .blog-item-preview .blog-field-date').forEach(function(field) {
		if (field.querySelector('.event-day')) {
			return;
		}
		const label = field.querySelector('.sr-only');
		const text = field.textContent.replace(label ? label.textContent : '', '').trim();
		const day = text.match(/\b(\d{1,2})\b/);
		const month = text.match(/[A-Za-zÀ-ÿ]+/);
		if (!day || !month) {
			return;
		}
		const spoken = document.createElement('span');
		spoken.className = 'sr-only';
		spoken.textContent = (label ? label.textContent.trim() + ' ' : '') + text;
		field.innerHTML = '';
		field.appendChild(spoken);
		const visual = document.createElement('span');
		visual.setAttribute('aria-hidden', 'true');
		visual.innerHTML = '<span class="event-day">' + day[1].padStart(2, '0') + '</span><span class="event-month">' + month[0].substring(0, 3).toLowerCase() + '</span>';
		field.appendChild(visual);
	});
});

onComplete(function() {
	// Agenda items show the title with the date and time beside it above the photo, and a right-hand
	// column with the back button, the flyer, tickets and entrance fee. The agenda view of the CMS has
	// a different order and is not overridable on this site, so visitors get this arrangement here.
	// Logged-in editors keep the original order, which keeps every block editable in place.
	if (document.documentElement.dataset.logged === 'true') {
		return;
	}
	const item = document.querySelector('.blog-template-agenda.blog-item .blog-content');
	const row = item ? item.querySelector(':scope > .row') : null;
	if (!row || row.children.length < 2) {
		return;
	}
	const main = row.children[0];
	const aside = row.children[1];
	const header = item.querySelector(':scope > .blog-content-header');
	const backLink = main.querySelector('.btn-back');
	const title = main.querySelector(':scope > h1');
	const fields = main.querySelector(':scope > .fields');
	const flyer = main.querySelector(':scope > [data-partial="partial-list"]');

	const head = document.createElement('div');
	head.className = 'row event-head';
	head.innerHTML = '<div class="col-12 col-lg-8"><div class="row"><div class="col-12 col-md-8 event-head-title"></div><div class="col-12 col-md-4 event-head-date"></div></div></div>';
	if (title) {
		head.querySelector('.event-head-title').appendChild(title);
	}
	if (fields) {
		const values = [...fields.querySelectorAll('li')].map(function(li) {
			const label = li.querySelector('.sr-only');
			return li.textContent.replace(label ? label.textContent : '', '').trim();
		}).filter(Boolean);
		const when = document.createElement('div');
		when.className = 'event-date h3';
		when.textContent = values.length > 1 ? values[0] + ' - ' + values[1].replace(' - ', ' tot ') : (values[0] || '');
		head.querySelector('.event-head-date').appendChild(when);
		fields.remove();
	}
	item.insertBefore(head, item.firstChild);

	main.className = 'col-12 col-lg-8 event-main';
	aside.className = 'col-12 col-lg-4 event-aside';
	if (header) {
		main.insertBefore(header, main.firstChild);
	}
	aside.querySelectorAll('.blog-content-form').forEach(function(form) {
		form.remove();
	});
	if (backLink) {
		aside.appendChild(backLink.parentElement);
	}
	if (flyer) {
		const flyerImages = document.createElement('div');
		flyerImages.className = 'event-flyer';
		flyer.querySelectorAll(':scope > [data-partial="image"]').forEach(function(image) {
			flyerImages.appendChild(image);
		});
		aside.appendChild(flyerImages);
	}
	const start = [...main.querySelectorAll('h3')].find(function(h) {
		return /^(Kaarten|Entree):/.test(h.textContent.trim());
	});
	let node = start;
	while (node) {
		const next = node.nextSibling;
		aside.appendChild(node);
		node = next;
	}
});

onComplete(function() {
	// Photo albums place every photo in the currently shortest column, working from left to right, so
	// the first photos line up across the top. CSS columns would fill one column at a time instead.
	// Editors keep the CMS default, so adding and sorting photos behaves as everywhere else.
	if (document.documentElement.dataset.logged === 'true') {
		return;
	}
	document.querySelectorAll('.page-album .masonry-vertical').forEach(function(album) {
		const items = [...album.querySelectorAll(':scope > a')];
		if (!items.length) {
			return;
		}
		album.classList.add('is-masonry');

		function layout() {
			const width = album.clientWidth;
			const columns = window.innerWidth >= 768 ? 3 : (window.innerWidth >= 576 ? 2 : 1);
			const share = columns === 3 ? 0.32 : (columns === 2 ? 0.48 : 1);
			const itemWidth = columns === 1 ? width - 10 : width * share;
			const heights = new Array(columns).fill(0);
			items.forEach(function(item) {
				item.style.width = itemWidth + 'px';
			});
			items.forEach(function(item) {
				const column = heights.indexOf(Math.min.apply(null, heights));
				item.style.left = (5 + column * (itemWidth + 10)) + 'px';
				item.style.top = (5 + heights[column]) + 'px';
				heights[column] += item.offsetHeight + 10;
			});
			album.style.height = Math.max.apply(null, heights) + 'px';
		}

		layout();
		window.addEventListener('resize', layout);
		items.forEach(function(item) {
			const image = item.querySelector('img');
			if (image && !image.complete) {
				image.addEventListener('load', layout);
			}
		});
	});
});
